var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSubscriptionIcon = function SvgSubscriptionIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3754_4957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33335 6.66667C9.33335 5.93029 8.7364 5.33333 8.00002 5.33333C7.26364 5.33333 6.66669 5.93029 6.66669 6.66667C6.66669 7.40305 7.26364 8 8.00002 8",
    stroke: "#595959",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 7.99999C8.7364 7.99999 9.33335 8.59694 9.33335 9.33332C9.33335 10.0697 8.7364 10.6667 8.00002 10.6667C7.26364 10.6667 6.66669 10.0697 6.66669 9.33332",
    stroke: "#595959",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4.33334V5.33334",
    stroke: "#595959",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10.6667V11.6667",
    stroke: "#595959",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 7.96875C15 11.8347 11.866 14.9687 8 14.9687C5.70985 14.9687 3.67658 13.869 2.39949 12.1687M1 7.96875C1 4.10276 4.13401 0.96875 8 0.96875C10.2901 0.96875 12.3234 2.06852 13.6005 3.76875",
    stroke: "#595959",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.39989 12.1689L1.69989 14.2689",
    stroke: "#595959",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6002 3.76891L14.3002 1.66891",
    stroke: "#595959",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3754_4957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSubscriptionIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "subscriptionIcon.536da2bc341fc750f21d84da598c8172.svg";